<template>
  <div class="file-input-wrapper">
    <v-hover v-slot="{ hover }">
      <div 
        class="import-area d-flex align-center pa-3 rounded-lg pointer transition-swing border-dashed"
        :class="{ 'hover-active elevation-1': hover, 'selecting-active': isSelecting }"
        @click="handleFileImport"
      >
        <v-avatar color="primary lighten-5" size="32" class="mr-3">
          <v-icon small :color="isSelecting ? 'primary' : 'primary darken-1'" :class="{ 'fa-spin': isSelecting }">
            {{ isSelecting ? 'fas fa-spinner' : 'fas fa-plus' }}
          </v-icon>
        </v-avatar>
        
        <div>
          <div class="text-caption font-weight-black primary--text text-uppercase tracking-wider lh-1">
            {{ isSelecting ? 'Explorando...' : 'Adjuntar Archivos' }}
          </div>
          <div class="x-small-text grey--text font-weight-medium mt-0.5" v-if="!isSelecting">
            Haz clic para seleccionar
          </div>
        </div>
        
        <v-spacer></v-spacer>
        <v-icon x-small color="grey lighten-1" class="ml-2">fas fa-chevron-right</v-icon>
      </div>
    </v-hover>

    <input 
      ref="uploader" 
      class="d-none" 
      type="file" 
      multiple
      @change="onFileChanged"
    >
  </div>
</template>

<script>
export default {
  name: 'FileInput',
  data() {
    return {
      isSelecting: false,
      selectedFile: null
    }
  },
  methods: {
    handleFileImport() {
      this.isSelecting = true;
      window.addEventListener('focus', () => {
        setTimeout(() => { this.isSelecting = false }, 500)
      }, { once: true });
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      if (e.target.files.length > 0) {
        this.selectedFile = Array.from(e.target.files);
        this.$emit('change', this.selectedFile);
      }
      this.selectedFile = null;
      e.target.value = '';
    },
  }
}
</script>

<style scoped>
.file-input-wrapper {
  width: 100%;
}
.import-area {
  border: 1.5px dashed rgba(var(--v-primary-base), 0.25);
  background-color: rgba(var(--v-primary-base), 0.02);
  transition: all 0.2s ease;
}
.import-area:hover {
  background-color: rgba(var(--v-primary-base), 0.05);
  border-color: var(--v-primary-base);
}
.hover-active {
  transform: translateY(-1px);
}
.selecting-active {
  border-color: var(--v-primary-base);
  background-color: rgba(var(--v-primary-base), 0.08);
}
.pointer {
  cursor: pointer;
}
.tracking-wider {
  letter-spacing: 1px;
}
.lh-1 {
  line-height: 1;
}
.x-small-text {
  font-size: 0.7rem;
}
</style>